import React from 'react';
import { RefreshCw, Moon, Sun } from 'lucide-react';
import styles from './PriceChangeLogs.module.css';
import PriceChangeLogsPanel from './PriceChangeLogsPanel';

const PriceChangeLogs: React.FC = () => {
  const [refreshSignal, setRefreshSignal] = React.useState(0);
  const [isDarkMode, setIsDarkMode] = React.useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    return document.documentElement.getAttribute('data-theme') === 'dark';
  });

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const handleRefresh = () => {
    setRefreshSignal((signal) => signal + 1);
  };

  const handleToggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          <h1>Price Change Logs</h1>
          <p>
            Every list-price change from admin, mobile, Victory Live auto sync, or VL email —
            with who changed it, whether QuickAsyst and Victory Live still match, and which client/event it belongs to.
          </p>
        </div>
        <div className={styles.headerActions}>
          <div className={styles.iconButtons}>
            <button
              type="button"
              className={styles.iconButton}
              onClick={handleRefresh}
              title="Refresh"
              aria-label="Refresh logs"
            >
              <RefreshCw size={18} />
            </button>
            <button
              type="button"
              className={styles.iconButton}
              onClick={handleToggleDarkMode}
              title={isDarkMode ? 'Light mode' : 'Dark mode'}
              aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
            </button>
          </div>
        </div>
      </div>

      <PriceChangeLogsPanel refreshSignal={refreshSignal} />
    </div>
  );
};

export default PriceChangeLogs;
